import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';

import {
  fetchDeleteOfferFromFavorites,
  IDeleteOfferFromFavoritesRequest,
} from '../../repositories/favorites/v1/delete-offer-from-favorites';
import { trackingActionRemoveFromCardJK } from './tracking';
import {
  EDealType,
  EEntityType,
} from '../../repositories/favorites/entities/schemas/DeleteOfferFromFavoritesRequestSchema';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import { IFavoriteThunkResult } from '../../types/redux/thunks';
import { gaLabelSelector, newbuildingIdSelector } from '../../selectors/newbuilding';

/* istanbul ignore next */
export const removeFavorite = createAsyncThunk<IFavoriteThunkResult, undefined, IThunkApi>(
  'favorites/removeFavorite',
  async (_doneText, _thunkApi) => {
    const {
      extra: { httpApi, logger },
      rejectWithValue,
      getState,
    } = _thunkApi;

    const state = getState();

    const gaLabel = gaLabelSelector(state);
    const newbuildingId = newbuildingIdSelector(state);

    const parameters: IDeleteOfferFromFavoritesRequest = {
      dealType: EDealType.Sale,
      entityType: EEntityType.Newbuilding,
      entityId: newbuildingId,
    };

    const trackActionRemove = trackingActionRemoveFromCardJK(gaLabel, newbuildingId);
    await trackActionRemove();

    try {
      const response: { statusCode: number } = await fetchDeleteOfferFromFavorites({ httpApi, parameters });

      if (response.statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          statusCode: response.statusCode,
          message: 'Ошибка запроса в delete-offer-from-favorites',
          domain: 'src/shared/thunks/favorites/favorites.ts',
        });
      }
    } catch (err) {
      logger.error(err, {
        message: err.message,
        stack: err.stack,
        comment: 'Ошибка запроса в delete-offer-from-favorites',
      });

      rejectWithValue(err);
    }

    return {
      isFavorite: false,
    };
  },
);
